type TripEditabilityInput = {
  creationSource: string;
  isEditable?: boolean | null;
  conciergeAssisted?: boolean | null;
};

type TripEditability = {
  isDateUnset: boolean;
  isReadOnly: boolean;
  canEditTripSelections: boolean;
};

export const deriveTripEditability = (overview: TripEditabilityInput | undefined): TripEditability => {
  const creationSource = overview?.creationSource ?? '';
  const isDateUnset = creationSource === 'STEP_BY_STEP';
  const isBlueprintOrPlayground =
    creationSource === 'FROM_TEMPLATE' ||
    creationSource === 'FROM_VIRTUAL_BLUEPRINT' ||
    creationSource === 'FROM_VIRTUAL_BLUEPRINT_TEMPLATE' ||
    creationSource.includes('PLAYGROUND');
  const isConciergeLocked = overview?.conciergeAssisted === true;
  const isStructurallyEditable =
    !isConciergeLocked && (overview?.isEditable ?? (isDateUnset || isBlueprintOrPlayground));

  return {
    isDateUnset,
    isReadOnly: overview !== undefined && !isStructurallyEditable,
    canEditTripSelections: !isConciergeLocked && overview?.isEditable !== false
  };
};
